// Nombor telefon Malaysia — carian admin + kemaskan simpanan (2026-09-30).
//
// Data sebenar (diukur 30 Sept, baca sahaja):
//   users      → 99.6% "+60XXXXXXXXX"; 3 akaun "60 19-760 2796" (edit manual admin, tampal dari WhatsApp)
//   orders     → nombor sahaja, dengan/tanpa "+" (60… / 0… / +60…)
//   affiliates → kebanyakan "0XXXXXXXXX" (tiada +60)
// Carian Users + Sales berjalan di server (padanan TEPAT `in`), jadi kita bina semua
// bentuk lazim termasuk format paparan WhatsApp. Affiliate tapis di client → guna terasNombor().

// Buang kod negara / awalan 0 → "197602796". Nombor MY tempatan bermula 1 (mobile), jadi selamat.
export function terasNombor(raw) {
    const d = String(raw || '').replace(/\D/g, '');
    if (d.startsWith('60')) return d.slice(2);
    if (d.startsWith('0')) return d.slice(1);
    return d;
}

// Rupa term macam nombor telefon? (hanya angka/jarak/+/-/kurungan/titik, ≥8 digit)
export function macamNombor(term) {
    const t = String(term || '').trim();
    return /^[\d\s+\-().]+$/.test(t) && t.replace(/\D/g, '').length >= 8;
}

// Format paparan WhatsApp: 9 digit "19-760 2796" · 10 digit "11-2345 6789".
function gayaWhatsapp(teras) {
    if (teras.length === 9) return `${teras.slice(0, 2)}-${teras.slice(2, 5)} ${teras.slice(5)}`;
    if (teras.length === 10) return `${teras.slice(0, 2)}-${teras.slice(2, 6)} ${teras.slice(6)}`;
    return null;
}

// Senarai calon untuk where('whatsappNumber', 'in', …). Firestore had 30 nilai.
export function calonCarianWhatsapp(term) {
    const t = String(term || '').trim();
    const digits = t.replace(/\D/g, '');
    const teras = terasNombor(digits);
    const calon = [`+60${teras}`, `60${teras}`, `0${teras}`, teras, digits, t];
    const g = gayaWhatsapp(teras);
    if (g) calon.push(`+60 ${g}`, `60 ${g}`, `0${g}`);
    return Array.from(new Set(calon.filter(Boolean))).slice(0, 30);
}

// Kemaskan nombor sebelum simpan (edit manual admin) → "+60XXXXXXXXX".
// Nombor luar negara ("+65…") dikekalkan sebagai "+digit"; input bukan nombor dikekalkan asal.
export function kemasNomborMy(raw) {
    const t = String(raw || '').trim();
    if (!t) return '';
    if (!/^[\d\s+\-().]+$/.test(t)) return t;
    const digits = t.replace(/\D/g, '');
    if (!digits) return t;
    if (t.startsWith('+') && !digits.startsWith('60')) return `+${digits}`;
    if (digits.startsWith('60')) return `+${digits}`;
    if (digits.startsWith('0')) return `+60${digits.slice(1)}`;
    if (digits.length === 9 || digits.length === 10) return `+60${digits}`;
    return t;
}
